import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotifyIncompleteFormsForReports {
  private fetchSubjectData = new Subject<void | boolean>();
  handleFetchData(val: boolean) {
    this.fetchSubjectData.next(val);
  }
  getMessage(): Observable<any> {
    return this.fetchSubjectData.asObservable();
  }
}
